// extracted by mini-css-extract-plugin
export default {"appWrapper":"AppWrapper_appWrapper__zWF5X","theme-light":"AppWrapper_theme-light__Zakz+","theme-dark":"AppWrapper_theme-dark__uMP6T"};